import React from "react";
import { Brain, Compass, Microscope } from "@phosphor-icons/react";

// Three mission pillars, extracted from About.jsx so the icon/eyebrow layout
// stays isolated from the rest of the page. Icon container is `display:flex`
// (not inline-flex) so the eyebrow drops to its own line beneath the icon.
const PILLARS = [
  {
    icon: Brain,
    eyebrow: "Support",
    title: "Therapy that meets you where you are",
    body: "Culturally-informed, evidence-led therapy and assessments. No jargon, no posturing, just clinicians who listen first.",
  },
  {
    icon: Compass,
    eyebrow: "Direction",
    title: "Mentorship for the work ahead",
    body: "Psychology mentors and career guides who've walked the routes you're considering, from DClinPsy to PhD to career change.",
  },
  {
    icon: Microscope,
    eyebrow: "Evidence",
    title: "Research that earns its keep",
    body: "ATLAS, our research and knowledge platform, turns lived experience into published insight, with a student ambassador programme.",
  },
];

export default function AboutPillarsSection() {
  return (
    <section className="md-section" data-testid="about-pillars-section" style={{ background: "#ffffff" }}>
      <div className="md-container">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <div className="md-label-eyebrow mb-3">How we work</div>
          <h2 className="text-3xl md:text-5xl font-serif">Three pillars. One ecosystem</h2>
          <p className="text-base mt-3" style={{ color: "var(--md-text-soft)" }}>
            Support, direction and evidence, connected, but distinct.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <article
                key={p.title}
                className="md-about-pillar-card"
                data-testid={`about-pillar-${p.eyebrow.toLowerCase()}`}
              >
                <div className="md-about-pillar-ico"><Icon size={26} weight="duotone" /></div>
                <div className="md-label-eyebrow">{p.eyebrow}</div>
                <h3 className="md-about-pillar-title font-serif mt-2">{p.title}</h3>
                <p className="md-about-pillar-body">{p.body}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
